import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73453b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_2 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_3 = {
  key: 0,
  class: "logo"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/WEAS_LOGO.png",
  alt: "WEAS_LOGO"
}, null, -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "left-group" }
const _hoisted_7 = { class: "date-range" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", {
  class: "el-icon el-icon-file-pdf fas",
  style: {"cursor":"pointer"}
}, null, -1))

import { getDatesWithEstimations } from "@/service/estimation.service";
import {
  getSamplingPointsNoRelations,
  getSamPointOnlyParameters,
} from "@/service/samplingpoint.service";
import { Parameter } from "@/types/parameter.type";
import { ReportFilter } from "@/types/report.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { onMounted, reactive, ref, watch, computed } from "vue";
import { ElMessage } from "element-plus";
import type { TabsPaneContext } from "element-plus";
import reportGraphAnalysis from "@/components/reports/reportGraphAnalysis.component.vue";
import reportNumericAnalysis from "@/components/reports/reportNumericAnalysis.component.vue";
import reportStatisticalAnalysis from "@/components/reports/reportStatisticalAnalysis.component.vue";
import newReportStatisticalAnalysis from "@/components/reports/newReportStatisticalAnalysis.component.vue"; // Nuevo
import { getParameter } from "@/service/parameter.service";
import { useRoute, RouteLocationNormalized } from "vue-router";
import { Filter } from "@/types/filter.type";
import securityService from "@/service/security.service";
import { AppRole } from "@/types/app.type";

import { rageDateFormat } from "@/utils/date.utils";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const reportAnalysis = ref<InstanceType<typeof reportStatisticalAnalysis> | null>(null);
const newReportAnalysis = ref<InstanceType<typeof newReportStatisticalAnalysis> | null>(null);

const reportFilter = reactive<ReportFilter>({
  samplingPointIds: [],
  parameterIds: [],
  date: [null, null],
});

const samplingPoints = ref<SamplingPoint[]>([]);
const tmoas = ref<number>(0);
const showNewReport = computed(() => Number(tmoas.value) > 0);
const parameters = ref<Parameter[]>([]);
const selectedSamplingPointIds = ref<number>();
const selectedParameter = ref<Parameter>();
const selectedParameters = ref<Parameter[]>([]);
const nameSapmplingPoint = ref<string>("");

const parameter1 = ref<number>();
const parameter2 = ref<number>();

const noData = ref<boolean>(true);
let datesWithEstimations = reactive<string[]>([]);

const isFormComplete = computed(() => {
  return (
    reportFilter.samplingPointIds &&
    parameter1.value &&
    reportFilter.date[0] &&
    reportFilter.date[1]
  );
});

const activeName = ref("first");
const disabled = ref<boolean>(false);
const showButton = ref<boolean>(true);
const isAppDemo = ref<boolean>(false);

const startDatePickerKey = ref(0);
const endDatePickerKey = ref(0);

// onMounted(async () => {
//   isAppDemo.value = securityService.hasRole(AppRole.DEMOS) ? true : false;

//   const fromRoute = route.meta.from as RouteLocationNormalized;

//   let samplingPointFromRoute: number | null = null;
//   if (fromRoute?.fullPath) {
//     const urlParams = new URLSearchParams(fromRoute.fullPath.split("?")[1]);
//     const samplingPointParam = urlParams.get("samplingPoint");
//     if (samplingPointParam) {
//       samplingPointFromRoute = Number(samplingPointParam);

//       reportFilter.samplingPointIds = [samplingPointFromRoute];
//       selectedSamplingPointIds.value = samplingPointFromRoute;
//     }
//   }

//   // samplingPoints.value = (await getSamplingPointsNoRelations())?.data || [];
//   samplingPoints.value = (await getSamplingPointsNoRelations())?.data || [];
//   samplingPoints.value.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));

//   const samplingPointId = route.query.samPoint;
//   const param = route.query.parameter;
//   if (route.query.startDate) {
//     reportFilter.date[0] = new Date(route.query.startDate.toString());
//   }
//   if (route.query.endDate) {
//     reportFilter.date[1] = new Date(route.query.endDate.toString());
//   }

//   const samplingPoint = samplingPoints.value.find((sp) => sp.id === Number(samplingPointId));
//   tmoas.value = Number(samplingPoint?.numTmoa) || 0;

//   if (samplingPoint && samplingPoint.id) {
//     reportFilter.samplingPointIds = [samplingPoint.id];
//     selectedSamplingPointIds.value = samplingPoint.id;
//   }

//   if (param) {
//     const filter: Filter = {
//       fields: {
//         "parameter.name": {
//           operator: "equal",
//           value: param,
//         },
//       },
//     };

//     const parameterData = await getParameter(undefined, undefined, filter);
//     const parameter = parameterData.data[0];

//     if (parameter?.id) {
//       reportFilter.parameterIds[0] = parameter.id;
//       parameter1.value = parameter.id;
//     }
//   }

//   if (reportFilter.samplingPointIds.length > 0) {
//     await loadParametersForSelectedSamplingPoint();
//   }

//   //Si viene de detalle del punto(Ver más), cargar grafica con los datos de la url
//   if (
//     reportFilter.samplingPointIds.length > 0 &&
//     parameter1.value &&
//     reportFilter.date[0] &&
//     reportFilter.date[1]
//   ) {
//     await getMarkedDates();
//     showResults();
//     return;
//   }

//   //Si viene de detalle del punto(Barra lateral), cargar grafica con los datos de sessionStorage
//   const startDateStr = sessionStorage.getItem("startDate");
//   const endDateStr = sessionStorage.getItem("endDate");
//   const parameterIdStr = sessionStorage.getItem("parameterId");

//   if (startDateStr && endDateStr && parameterIdStr) {
//     reportFilter.date[0] = new Date(startDateStr);
//     reportFilter.date[1] = new Date(endDateStr);

//     const parameterId = Number(parameterIdStr);
//     reportFilter.parameterIds[0] = parameterId;
//     parameter1.value = parameterId;

//     if (reportFilter.samplingPointIds.length > 0) {
//       await loadParametersForSelectedSamplingPoint();

//       const parameterData = parameters.value.find((p) => p.id === parameterId);
//       if (parameterData) {
//         selectedParameter.value = parameterData;
//         selectedParameters.value[0] = parameterData;
//       }
//     }

//     await getMarkedDates();
//     showResults();

//     sessionStorage.removeItem("startDate");
//     sessionStorage.removeItem("endDate");
//     sessionStorage.removeItem("parameterId");
//   }
// });

const isValidNumber = (value: unknown): value is number =>
  value !== null && value !== undefined && !isNaN(Number(value));

const safeDate = (value: unknown): Date | null => {
  const d = new Date(String(value));
  return isNaN(d.getTime()) ? null : d;
};

onMounted(async () => {
  isAppDemo.value = securityService.hasRole(AppRole.DEMOS);

  samplingPoints.value = (await getSamplingPointsNoRelations())?.data || [];
  samplingPoints.value.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));

  const urlSamPoint = isValidNumber(route.query.samPoint) ? Number(route.query.samPoint) : null;

  const fromRoute = route.meta.from as RouteLocationNormalized | undefined;
  let metaSamPoint: number | null = null;

  if (fromRoute?.fullPath?.includes("?")) {
    const params = new URLSearchParams(fromRoute.fullPath.split("?")[1]);
    metaSamPoint = isValidNumber(params.get("samplingPoint"))
      ? Number(params.get("samplingPoint"))
      : null;
  }

  const samplingPointId = urlSamPoint ?? metaSamPoint;

  const samplingPoint = samplingPoints.value.find((sp) => sp.id === samplingPointId);

  if (samplingPoint && samplingPoint.id) {
    reportFilter.samplingPointIds = [samplingPoint.id];
    selectedSamplingPointIds.value = samplingPoint.id;
    tmoas.value = Number(samplingPoint.numTmoa) || 0;
    await loadParametersForSelectedSamplingPoint();
  } else {
    clearFilters();
    return;
  }

  reportFilter.date[0] = safeDate(route.query.startDate);
  reportFilter.date[1] = safeDate(route.query.endDate);

  if (route.query.parameter) {
    const filter: Filter = {
      fields: {
        "parameter.name": {
          operator: "equal",
          value: route.query.parameter,
        },
      },
    };

    const parameterData = await getParameter(undefined, undefined, filter);
    const param = parameterData.data?.[0];

    if (param?.id) {
      parameter1.value = param.id;
      reportFilter.parameterIds[0] = param.id;
    }
  }

  if (isFormComplete.value) {
    await getMarkedDates();
    showResults();
    return;
  }

  const startDate = safeDate(sessionStorage.getItem("startDate"));
  const endDate = safeDate(sessionStorage.getItem("endDate"));
  const paramId = isValidNumber(sessionStorage.getItem("parameterId"))
    ? Number(sessionStorage.getItem("parameterId"))
    : null;

  if (startDate && endDate && paramId) {
    reportFilter.date = [startDate, endDate];
    parameter1.value = paramId;
    reportFilter.parameterIds[0] = paramId;

    const paramData = parameters.value.find((p) => p.id === paramId);
    if (paramData) {
      selectedParameter.value = paramData;
      selectedParameters.value = [paramData];
    }

    await getMarkedDates();
    showResults();
  }

  sessionStorage.clear();
});

// const handleEndDateChange = async (date: Date | null) => {
//   await getMarkedDates();

//   if (!date) {
//     reportFilter.date[1] = null;
//     return;
//   }

//   if (date.getHours() === 0 && date.getMinutes() === 0) {
//     const adjustedDate = new Date(date);
//     adjustedDate.setHours(23, 59, 59, 999);
//     reportFilter.date[1] = adjustedDate;
//   } else {
//     reportFilter.date[1] = date;
//   }
// };

const exportInfo = async () => {
  console.log("QWERT");
  if (tmoas.value !== 0) {
    await newReportAnalysis.value?.btnExportToPdf();
  } else {
    await reportAnalysis.value?.btnExportToPdf();
  }
};

const hasEstimatedData = (day: Date) => {
  return datesWithEstimations.includes(day.toDateString());
};

const disabledData = (date: Date) => {
  return !datesWithEstimations.includes(date.toDateString());
};

const updateParameterIds = (index: number) => {
  if (index === 0) {
    if (parameter1.value) {
      reportFilter.parameterIds[index] = parameter1.value;
    } else {
      reportFilter.parameterIds[index] = 0;
      reportFilter.date = [null, null];
      parameter2.value = undefined;
    }
  } else if (index === 1) {
    if (parameter2.value) {
      reportFilter.parameterIds[index] = parameter2.value;
    } else {
      reportFilter.parameterIds[index] = 0;
      selectedParameters.value = selectedParameters.value.slice(0, 1);
      selectedParameter.value = selectedParameters.value[0];
    }
  }
};

const loadParametersForSelectedSamplingPoint = async () => {
  if (!reportFilter.samplingPointIds[0]) {
    selectedSamplingPointIds.value = undefined;
    clearFilters();
    return;
  }

  selectedSamplingPointIds.value = reportFilter.samplingPointIds[0];
  const ids = Array.isArray(selectedSamplingPointIds.value)
    ? selectedSamplingPointIds.value
    : [selectedSamplingPointIds.value];

  const parametersPromises = ids.map((id) => getSamPointOnlyParameters(id));
  const parameterSets = await Promise.all(parametersPromises);
  const allParameters = parameterSets.reduce((acc, parameters) => acc.concat(parameters), []);
  parameters.value = removeDuplicateParameters(allParameters);

  let order = [
    "TU",
    "SS",
    "SD",
    "MES",
    "CE",
    "RE",
    "DQ",
    "DB",
    "CO",
    "CT",
    "NT",
    "NO",
    "OD",
    "PH",
    "FO",
    "FT",
    "OR",
    "NH",
    "FE",
    "MN",
    "AYG",
    "ES",
    "LE",
    "RET",
    "CR",
    "CR",
    "AVA",
    "AVE",
    "CL_AVA",
    "CL_AVE",
    "CL_DI",
    "CL_CR",
    "CL_T",
    "CAS_CR",
    "CAS_DI",
    "CAS_T",
  ];
  parameters.value.sort((a, b) => {
    const indexA = order.indexOf(a.code ?? "");
    const indexB = order.indexOf(b.code ?? "");

    // Si no está en el orden, que vaya al final
    return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  });
};

const removeDuplicateParameters = (parameters: Parameter[]) => {
  const uniqueParameters = [];
  const uniqueParameterIds = new Set();

  for (const param of parameters) {
    if (!uniqueParameterIds.has(param.id)) {
      uniqueParameterIds.add(param.id);
      uniqueParameters.push(param);
    }
  }
  noData.value = true;
  return uniqueParameters;
};

const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};

const showResults = () => {
  if (reportFilter.date[0] && reportFilter.date[1] && reportFilter.date[0] > reportFilter.date[1]) {
    ElMessage.warning("La fecha de inicio debe ser anterior a la fecha de fin.");
    return;
  }
  noData.value = false;
  showButton.value = true;
};

const clearFilters = () => {
  reportFilter.samplingPointIds = [];
  reportFilter.parameterIds = [];
  reportFilter.date = [null, null];
};

const handleEndDateChange = async (date: Date | null) => {
  if (!date) {
    reportFilter.date[1] = null;
    return;
  }

  if (date.getHours() === 0 && date.getMinutes() === 0) {
    const adjustedDate = new Date(date);
    adjustedDate.setHours(23, 59, 59, 999);
    if (reportFilter.date[1]?.getTime() !== adjustedDate.getTime()) {
      reportFilter.date[1] = adjustedDate;
    }
  }

  await getMarkedDates();
};

watch(
  () => reportFilter.samplingPointIds[0],
  async (newId) => {
    if (!newId) {
      reportFilter.parameterIds = [];
      reportFilter.date = [null, null];
      tmoas.value = 0;
      return;
    }

    const point = samplingPoints.value.find((sp) => sp.id === newId);
    tmoas.value = Number(point?.numTmoa) || 0;

    parameter1.value = undefined;
    parameter2.value = undefined;

    await loadParametersForSelectedSamplingPoint();
  }
);

watch(parameter1, async (newVal) => {
  if (newVal) {
    reportFilter.parameterIds[0] = newVal;
    const found = parameters.value.find((p) => p.id === newVal);
    if (found) {
      selectedParameter.value = found;
      selectedParameters.value[0] = found;
    }

    if (parameter2.value === newVal) {
      parameter2.value = undefined;
      if (reportFilter.parameterIds.length > 1) {
        reportFilter.parameterIds.splice(1, 1);
      }
    }

    await getMarkedDates();
  }
});

watch(parameter2, async (newVal) => {
  if (newVal) {
    reportFilter.parameterIds[1] = newVal;
    const found = parameters.value.find((p) => p.id === newVal);
    if (found) {
      selectedParameters.value[1] = found;
    }
    await getMarkedDates();
  }
});

watch(isFormComplete, (complete) => {
  if (complete) {
    const sp = samplingPoints.value.find((c) => c.id === reportFilter.samplingPointIds[0]);
    nameSapmplingPoint.value = sp?.name || "";

    getMarkedDates();
    showResults();
  } else {
    noData.value = true;
  }
});

const getMarkedDates = async () => {
  const spId = reportFilter.samplingPointIds[0];
  const pId = reportFilter.parameterIds[0];

  if (!spId || !pId) return;

  try {
    const response = await getDatesWithEstimations([spId], [pId]);
    const newDates = response.map((date) => new Date(date.image_date).toDateString());

    if (JSON.stringify(datesWithEstimations) !== JSON.stringify(newDates)) {
      datesWithEstimations.splice(0, datesWithEstimations.length, ...newDates);
      startDatePickerKey.value++;
      endDatePickerKey.value++;
    }
  } catch (error) {
    console.error("Error loading dates:", error);
  }
};

// watch(isFormComplete, (complete) => {
//   if (complete) {
//     getMarkedDates();
//     showResults();
//     nameSapmplingPoint.value =
//       samplingPoints.value.find((c) => c.id === reportFilter.samplingPointIds[0])?.name || "";
//   } else {
//     noData.value = true;
//   }
// });

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_center = _resolveComponent("center")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, {
      class: "header-import page-title",
      style: {"margin-bottom":"5px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("text.reportService")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              class: "app-main-full-height-lg-and-up",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.samplingPoint")), 1),
                    _createVNode(_component_el_form_item, {
                      prop: "samplingPointIds",
                      class: "full-width-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(reportFilter).samplingPointIds[0],
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(reportFilter).samplingPointIds[0]) = $event)),
                          filterable: "",
                          clearable: "",
                          style: {"width":"100%"},
                          onChange: loadParametersForSelectedSamplingPoint,
                          placeholder: "Seleccionar",
                          disabled: disabled.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingPoints.value, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.id,
                                label: isAppDemo.value ? option.id : option.name,
                                value: option.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.parameter")) + " 1", 1),
                    _createVNode(_component_el_form_item, {
                      prop: "parameterIds",
                      class: "full-width-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: parameter1.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((parameter1).value = $event)),
                          filterable: "",
                          clearable: "",
                          style: {"width":"100%"},
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (updateParameterIds(0))),
                          disabled: disabled.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parameters.value, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.id,
                                label: option.name,
                                value: option.id,
                                disabled: option.id === parameter2.value
                              }, null, 8, ["label", "value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.parameter")) + " 2", 1),
                    _createVNode(_component_el_form_item, {
                      prop: "parameterIds",
                      class: "full-width-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: parameter2.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((parameter2).value = $event)),
                          filterable: "",
                          clearable: "",
                          style: {"width":"100%"},
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (updateParameterIds(1))),
                          disabled: disabled.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parameters.value, (option) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: option.id,
                                label: option.name,
                                value: option.id,
                                disabled: option.id === parameter1.value
                              }, null, 8, ["label", "value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.periodStartDate")), 1),
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "full-width-item"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: startDatePickerKey.value,
                          modelValue: _unref(reportFilter).date[0],
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(reportFilter).date[0]) = $event)),
                          type: "datetime",
                          style: {"width":"100%"},
                          "disabled-date": disabledData,
                          format: "YYYY-MM-DD HH:mm",
                          placeholder: "DD/MM/AAAA hh:mm",
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (getMarkedDates())),
                          disabled: 
                  _unref(reportFilter).samplingPointIds.length === 0 ||
                  _unref(reportFilter).parameterIds.length === 0 ||
                  disabled.value
                
                        }, {
                          default: _withCtx((cell) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["cell", { current: cell.isCurrent }])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass({ text: true, nodata: !hasEstimatedData(cell.date) })
                              }, _toDisplayString(cell.text), 3),
                              (hasEstimatedData(cell.date))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.periodEndDate")), 1),
                    _createVNode(_component_el_form_item, {
                      prop: "date",
                      class: "full-width-item"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_el_date_picker, {
                          key: endDatePickerKey.value,
                          modelValue: _unref(reportFilter).date[1],
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(reportFilter).date[1]) = $event)),
                          type: "datetime",
                          style: {"width":"100%"},
                          "disabled-date": disabledData,
                          format: "YYYY-MM-DD HH:mm",
                          placeholder: "DD/MM/AAAA hh:mm",
                          onChange: handleEndDateChange,
                          disabled: 
                  _unref(reportFilter).samplingPointIds.length === 0 ||
                  _unref(reportFilter).parameterIds.length === 0 ||
                  disabled.value
                
                        }, {
                          default: _withCtx((cell) => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["cell", { current: cell.isCurrent }])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass({ text: true, nodata: !hasEstimatedData(cell.date) })
                              }, _toDisplayString(cell.text), 3),
                              (hasEstimatedData(cell.date))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 24,
                  style: {"width":"100%","margin-top":"10px"}
                }, {
                  default: _withCtx(() => [
                    (showButton.value)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          style: {"width":"100%"},
                          onClick: clearFilters
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("label.resetFilters")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 19 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "app-main-full-height-lg-and-up" }, {
              default: _withCtx(() => [
                (!_unref(isFormComplete))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_center, null, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.report")), 1)
                        ]),
                        _: 1
                      }),
                      _hoisted_4
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_el_tabs, {
                        modelValue: activeName.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((activeName).value = $event)),
                        type: "card",
                        class: "demo-tabs",
                        onTabClick: handleClick
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tab_pane, {
                            label: 'Análisis gráfico',
                            name: "first"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(reportGraphAnalysis, { reportFilter: _unref(reportFilter) }, null, 8, ["reportFilter"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tab_pane, {
                            label: 'Análisis estadístico',
                            name: "second"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_row, { class: "sub" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_el_select, {
                                        modelValue: selectedParameter.value,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedParameter).value = $event)),
                                        filterable: "",
                                        st: "",
                                        "value-key": "id"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedParameters.value, (option) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: option.id,
                                              label: option.name,
                                              value: option
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(reportFilter).date ? _unref(rageDateFormat)(_unref(reportFilter).date) : "-"), 1)
                                  ]),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    style: {"color":"white"},
                                    onClick: exportInfo,
                                    title: _ctx.$t('btn.exportToPDF')
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["title"])
                                ]),
                                _: 1
                              }),
                              (_unref(showNewReport))
                                ? (_openBlock(), _createBlock(newReportStatisticalAnalysis, {
                                    ref_key: "newReportAnalysis",
                                    ref: newReportAnalysis,
                                    key: 'new-report',
                                    reportFilter: _unref(reportFilter),
                                    parameter: selectedParameter.value,
                                    point: nameSapmplingPoint.value,
                                    date: _unref(reportFilter).date ? _unref(rageDateFormat)(_unref(reportFilter).date) : '-'
                                  }, null, 8, ["reportFilter", "parameter", "point", "date"]))
                                : _createCommentVNode("", true),
                              (!_unref(showNewReport))
                                ? (_openBlock(), _createBlock(reportStatisticalAnalysis, {
                                    ref_key: "reportAnalysis",
                                    ref: reportAnalysis,
                                    key: 'old-report',
                                    reportFilter: _unref(reportFilter),
                                    parameter: selectedParameter.value,
                                    point: nameSapmplingPoint.value,
                                    date: _unref(reportFilter).date ? _unref(rageDateFormat)(_unref(reportFilter).date) : '-'
                                  }, null, 8, ["reportFilter", "parameter", "point", "date"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tab_pane, {
                            label: 'Análisis numérico',
                            name: "third"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(reportNumericAnalysis, { reportFilter: _unref(reportFilter) }, null, 8, ["reportFilter"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})